import { React, useState, useEffect } from 'react';

import useToken from '../../util/useToken';

import { getAllImages } from '../../util/api';
import { permDeleteImage } from '../../util/api';

import './DeleteImage.css';

export default function DeleteImage () {
    const { token, setToken, removeToken, validToken} = useToken();
    const [ images, setimages ] = useState({"results":[]})
    const [ selectedId, setSelectedId ] = useState(null);
    const [ refresh, setRefresh ] = useState(false);

    //Pagination variables
    const [ page, setPage ] = useState(1) 
    const [ editedPage, setEditedPage] = useState(1);
    const [ pageSize, setPageSize ] = useState(5)
    const [ resultCount, setResultCount ] = useState(0);

    useEffect(() => {
        const handleimages = async () => {
            let info = await getAllImages(token, page, pageSize)
            setimages(info)
            setResultCount(parseInt(info["resultCount"]))

        }
        handleimages()
        setRefresh(false)
    }, [page, refresh, pageSize])


    const handleDelete = () => {
        permDeleteImage(token, selectedId).then(response => {
            response.json().then(json => {
                if(response.status !== 200){
                    alert(json["message"])
                }else{
                    setRefresh(true)
                }
            })
        })
    }

    const handleCheckboxChange = (event, id) => {
        if(id === selectedId){
            setSelectedId(null)
        }else{
            setSelectedId(id)
        }
    };

    const handleFowardClick = () => {
        if(page < (resultCount / pageSize)){
            setPage(page + 1)
        }
    }

    const handleBackClick = () => {
        if(page > 1 ){
            setPage(page - 1)
        }
    }

    return (
        <div className="container">
            <div className="image-container">
                <h2>Images</h2>
                <div>
                    <div className="image-table-buttons">
                        <div>
                            <button disabled={selectedId == null} onClick={() => {handleDelete();}}>Delete</button>
                        </div>
                        <div>
                            <button onClick={() => {handleBackClick()}}>{"<"}</button>
                            <input
                                className="page-input"
                                type="number"
                                value={editedPage}
                                onChange={(event) => {setEditedPage(event.target.valueAsNumber || editedPage)}}
                                onBlur={(event) => {
                                    const enteredPage = event.target.valueAsNumber || editedPage;
                                    const maxPage = Math.ceil(resultCount / pageSize);
                                    setPage(Math.max(1, Math.min(enteredPage, maxPage)));
                                    setEditedPage(Math.max(1, Math.min(enteredPage, maxPage)));
                                }}
                            />
                            <button onClick={() => {handleFowardClick()}}>{">"}</button>
                        </div>
                    </div>
                    <table className="image-table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Type</th>
                                <th>Link</th>
                            </tr>
                        </thead>
                        <tbody>
                            {images?.results?.map((result) => (
                            <tr key={result.id}>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={selectedId === result.id}
                                        onChange={event => handleCheckboxChange(event, result.id)}
                                    />
                                </td>
                                <td>{result.imageType?.value}</td>
                                <td>{result.imageLink}</td>
                            </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {resultCount !== 0 ? <p>{page}/{Math.ceil(resultCount/pageSize)}</p> : <p></p>}
            </div>
        </div>
    );
} 